module.exports = __webpack_public_path__ + "static/media/whatapp.c9414543.svg";